// extracted by mini-css-extract-plugin
module.exports = {"ImagePanel":"ImagePanel_ImagePanel__29-BQ"};